import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import PointManager from "../PointManager";
import AngleManager from "../AngleManager";
import LineManager from "../LineManager";
import { runCircleAnimation } from "./CircleAnimationSequence";
import AngleBgManager from "../AngleBgManager";
import Circle from "../../../../../../src/entities/Circle";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { generateRotationAngles } from "./helpers/drawRotationHelpers";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class AnimationManager {
  private isSwitcherActive = false;

  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private AngleBgManager: AngleBgManager,
    private LineManager: LineManager,
    private circle: Circle
  ) {
    generateRotationAngles(this.PointManager, 0);
    this.AngleManager.draw(PointManager.getPoints(), false);
    this.addCircAnimBut();
    eventBus.on(EnumEventBus.segmentMode, v => this.isSwitcherActive = v);
  }
  
  getDelayForStartAnim = () => this.isSwitcherActive ? 150 : 0;
  addCircAnimBut = () => new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim());
  
  runAnimations() {
    rootEventBus.emit(EnumRootEventBus.startedCircleAnim);
    const context: ContextType = {
      circle: this.circle,
      LineManager: this.LineManager,
      PointManager: this.PointManager,
      AngleManager: this.AngleManager,
      AngleBgManager: this.AngleBgManager
    }
    const completedCircleAnim = () => {
      rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
    }
    runCircleAnimation(context, () => completedCircleAnim())
  }
}
